import { Dispatch, SetStateAction } from 'react'

import { OperatorSearchCondition } from '@/common/api/modules/operator'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { Operator } from '@/common/model/operator'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import OperatorListRow from '@/components/container/modules/admin/operator/table/OperatorListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem checkbox sticky={0} float={float} {...rectProps(0)}>
        <Text size={12} color={TextColor.SECONDARY}>
          ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>
          メールアドレス
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text size={12} color={TextColor.SECONDARY}>
          名前
        </Text>
      </TableHeadItem>
    </>
  )
}

interface Props {
  operators: Operator[]
  condition: OperatorSearchCondition
  setCondition: Dispatch<SetStateAction<OperatorSearchCondition>>
  onUpdatePage: (page: number) => void
  total: number
}

const OPERATOR_TABLE_COLUMN_LENGTH = 3

const OperatorListTable = ({ operators, condition, onUpdatePage, total }: Props) => {
  const listFollowProps = useListScrollFollow(OPERATOR_TABLE_COLUMN_LENGTH)
  const { header } = listFollowProps

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {operators.map((operator) => (
            <OperatorListRow key={operator.id} operator={operator} isScrolled={header.isScrolled} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default OperatorListTable
